<script setup lang="ts">
defineProps<{
  isMobileHeaderToggled: boolean;
}>();

const emit = defineEmits(["toggle-burger"]);
</script>

<template>
  <div
    class="h-[26px] w-8 z-20 flex flex-col justify-between self-center cursor-pointer group"
    @click="emit('toggle-burger')"
  >
    <!-- Line 1 -->
    <div
      class="h-1 w-full rounded-lg bg-text-light origin-top-left transition-transform duration-300 ease-in-out group-hover:brightness-110"
      :class="{ 'rotate-45': isMobileHeaderToggled }"
    ></div>

    <!-- Line 2 -->
    <div
      class="h-1 w-full rounded-lg bg-text-light transition-transform duration-100 ease-in-out group-hover:brightness-110"
      :class="{ 'scale-y-0': isMobileHeaderToggled }"
    ></div>

    <!-- Line 3 -->
    <div
      class="h-1 w-full rounded-lg bg-text-light origin-bottom-left transition-transform duration-300 ease-in-out group-hover:brightness-110"
      :class="{ '-rotate-45': isMobileHeaderToggled }"
    ></div>
  </div>
</template>
